export const convertUserStatus = value => {
  let status = '';

  switch (value) {
    case 'UNCONFIRMED':
      status = 'user.status.unconfirmed';
      break;
    case 'CONFIRMED':
      status = 'user.status.confirmed';
      break;
    case 'FORCE_CHANGE_PASSWORD':
      status = 'user.status.force_change_password';
      break;
    case 'ARCHIVED':
      status = 'user.status.archived';
      break;
    case 'COMPROMISED':
      status = 'user.status.compromised';
      break;
    case 'RESET_REQUIRED':
      status = 'user.status.reset_required';
      break;
    default:
      status = 'user.status.default';
  }

  return status;
};
